import PayFixedAllowance from '@/api/hr/pay-fixed-allowance'
import Employee from '@/api/hr/employee'
import AllowanceItem from '@/api/hr/pay-item-allowance'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employees: [],
  allowances: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  RECEIVE_EMPLOYEES(state, employees) {
    state.employees = employees
  },

  RECEIVE_ALLOWANCES(state, allowances) {
    state.allowances = allowances
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayFixedAllowance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayFixedAllowance.store(data)
  },

  update(context, { id, ...data }) {
    return PayFixedAllowance.update(id, data)
  },

  destroy(context, id) {
    return PayFixedAllowance.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.record_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_employee_profiles: 'employee_id,employee_name_en'
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchAllowances(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        pay_item_deduction: 'allowance_id,allowance_item'
      },
      ...attributes
    }

    return AllowanceItem.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params
    }).then(response => {
      context.commit('RECEIVE_ALLOWANCES', response.data)
      return Promise.resolve(response)
    })
  }
}
